import { Text, View } from 'react-native'
import { Icon, symbolName } from '@/src/components/ui/Icon'
import { formatMeasurementReminderDurationLabel } from '@/src/features/dashboard/utils/measurement-reminder-duration'
import { colors } from '@/src/theme'
import { body2 } from '@/src/theme/typography'
import { useTranslation } from 'react-i18next'

const NON_SCALING_TEXT_PROPS = {
  allowFontScaling: false,
  maxFontSizeMultiplier: 1,
} as const

function ClockIcon() {
  return (
    <Icon
      name={symbolName('clock', 'schedule')}
      size={18}
      color={colors.inkSecondary}
    />
  )
}

export interface VoiceAssessmentDurationRowProps {
  /** Estimated session duration from the session definition API. */
  timeEstimateMinutes?: number | null
}

export function VoiceAssessmentDurationRow({
  timeEstimateMinutes,
}: VoiceAssessmentDurationRowProps = {}) {
  const { t } = useTranslation(['onboarding', 'dashboard'])
  const formatted = formatMeasurementReminderDurationLabel({
    estimatedDurationMinutes: timeEstimateMinutes,
    minutesShortLabel: t('dashboard:minutes_short'),
  })
  const label =
    formatted != null
      ? t('onboarding:voice_assessment.duration_about', {
          duration: formatted,
        })
      : t('onboarding:voice_assessment.duration')

  return (
    <View className="flex-row items-center justify-center self-center gap-2">
      <ClockIcon />
      <Text
        {...NON_SCALING_TEXT_PROPS}
        style={[body2, { color: colors.inkSecondary }]}
      >
        {label}
      </Text>
    </View>
  )
}
